import Vue from 'vue';

/**
 * 后台不可达 / 网关错误时进入维护白页（与 api 拦截器联动）
 */
export const maintenanceStore = Vue.observable({
  active: false
});

export function setMaintenanceActive(value) {
  maintenanceStore.active = !!value;
}
